import * as z from 'zod';

export const selectInputStringSchema = (isOptional = true) =>
  z
    .object({ name: z.string(), value: z.string() })
    .refine(({ value }) => isOptional || value !== '', "Field can't be None");

export type TSelectInputStringSchema = z.infer<ReturnType<typeof selectInputStringSchema>>;

export const selectInputNumberSchema = (isOptional = true) =>
  z
    .object({ name: z.string(), value: z.number() })
    .refine(({ value }) => isOptional || value !== -1, "Field can't be None");

export type TSelectInputNumberSchema = z.infer<ReturnType<typeof selectInputNumberSchema>>;
